// extracted by mini-css-extract-plugin
export default {"contents":"vG-z","sectionHeading":"wG-z"};